import {format} from "date-fns";
import {toZonedTime} from "date-fns-tz";

export function formatDateMST(dateInput: string | Date): string {
  const d = new Date(dateInput);
  if (isNaN(d.getTime())) return "-";

  const timeZone = "America/Denver";
  const zonedDate = toZonedTime(d, timeZone);

  return `${format(zonedDate, "yyyy-MM-dd")}`;
}
